import Text from '../../canvas/text'
import { FONT_SIZE, OFFSET, TextAlign, TextBaseline, getTimeframeLabel } from '../../constants/common'
import Chart from '../../models/chart'
import ChartLayoutModel from '../../models/chart_layout'
import { getChartLayoutSettings } from '../../models/settings'
import { getChangeColor, getTickerChange } from '../../utils/chart'

interface IRenderTickerTimeframeChange {
  chartLayoutModel: ChartLayoutModel
  canvasContext: CanvasRenderingContext2D
  chartModel: Chart
}

export function renderTickerTimeframeChange({
  chartLayoutModel,
  canvasContext,
  chartModel,
}: IRenderTickerTimeframeChange) {
  const { ChartSettings } = getChartLayoutSettings(chartLayoutModel)
  const { Colors, settingsHeight } = ChartSettings.general

  canvasContext.translate(0, settingsHeight * -1)

  const data = chartModel.quote()
  const pane = chartModel.panes().first()
  const availableWidth = chartModel.width
  const baselineY = (settingsHeight + ChartSettings.top.height) / 2
  new Text(
    {
      text: data.name || data.ticker,
      x: OFFSET.M,
      y: baselineY,
      font: { size: FONT_SIZE.XXL, style: 'bold' },
      fillStyle: Colors.text,
      textBaseline: TextBaseline.middle,
    },
    pane
  ).render(canvasContext)

  new Text(
    {
      text: getTimeframeLabel(data.timeframe),
      x: availableWidth / 2,
      y: baselineY,
      font: { size: FONT_SIZE.L, style: 'bold' },
      fillStyle: Colors.textSecondary,
      textAlign: TextAlign.center,
      textBaseline: TextBaseline.middle,
    },
    pane
  ).render(canvasContext)

  const { tickerChange, tickerAfterChange } = getTickerChange({ data })

  if (tickerChange) {
    const changeText = new Text(
      {
        text: tickerChange.string,
        x: availableWidth - OFFSET.M,
        y: baselineY,
        font: { size: FONT_SIZE.L, style: 'bold' },
        textAlign: TextAlign.right,
        textBaseline: TextBaseline.middle,
        fillStyle: getChangeColor({ change: tickerChange.points, ChartSettings }),
      },
      pane
    )
    if (tickerAfterChange) {
      new Text(
        {
          text: tickerAfterChange.string,
          x: availableWidth - OFFSET.M,
          y: baselineY + baselineY / 2,
          font: { size: FONT_SIZE.M, style: 'bold' },
          textAlign: TextAlign.right,
          textBaseline: TextBaseline.middle,
          fillStyle: getChangeColor({ change: tickerAfterChange.points, ChartSettings }),
        },
        pane
      ).render(canvasContext)

      changeText.set({ y: baselineY / 2, font: { size: FONT_SIZE.M, style: 'bold' } })
    }
    changeText.render(canvasContext)
  }

  canvasContext.translate(0, settingsHeight)
}
